export default [
  {
    path: '/football',
    name: 'football',
    component: () => import('@/views/football/football'),
    meta: { title: '比赛', keepAlive: true }
  },
  {
    path: '/footballInfo',
    name: 'footballInfo',
    component: () => import('@/views/football/footballInfo'),
    meta: { title: '详情' }
  },
  {
    path: '/footballOrder',
    name: 'footballOrder',
    component: () => import('@/views/football/footballOrder'),
    meta: { title: '投注记录' }
  },
  {
    path: '/footballActivity',
    name: 'footballActivity',
    component: () => import('@/views/football/footballActivity'),
    meta: { title: '活动' }
  },
  {
    path: '/footballActivityInfo',
    name: 'footballActivityInfo',
    component: () => import('@/views/football/footballActivityInfo'),
    meta: { title: '我的竞猜' }
  },
  {
    path: '/footballOrderInfo',
    name: 'footballOrderInfo',
    component: () => import('@/views/football/footballOrderInfo'),
    meta: { title: '详情' }
  },
]



// WEBPACK FOOTER //
// ./src/router/config/footballRouter.js